module.exports = __webpack_public_path__ + "public/SiteIcons/envelope.png?5a12ec1d";